import { render, staticRenderFns } from "./v-dropdown.vue?vue&type=template&id=3f2c1019&"
import script from "./v-dropdown.vue?vue&type=script&lang=js&"
export * from "./v-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./v-dropdown.vue?vue&type=style&index=0&id=3f2c1019&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports